module.exports = __webpack_public_path__ + "img/HörNix.a5069b1d.jpg";